<template>
  <div>
    <van-popup
      :style="{ width: '303px', height: '244px', borderRadius: '10px' }"
      v-model="popupLb"
    >
      <div class="prompt">
        <p>请选择新增身份类型</p>
        <div class="content">
          <div @click="goEnterprise" class="content-item1">企业身份</div>
          <div
            @click="goPersonal"
            :class="['content-item1', isIdentity ? '' : 'content-item2']"
          >
            个人身份
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: "newIdentityPop",
  props: ["isIdentity"],
  data() {
    return {
      popupLb: false,
    };
  },

  methods: {
    //   跳转企业认证
    goEnterprise() {
      localStorage.setItem("isFirst", "");
      localStorage.setItem("companyBack", window.location.href);
      localStorage.setItem("livingToPage", window.location.href);
      this.$router.replace({ path: "/enterpriseDetail", query: {} });
    },

    // 跳转到个人认证页面
    goPersonal() {
      if (!this.isIdentity) {
        this.$toast({
          message: "个人身份仅能绑定一个哟",
          duration: 1000,
        });
        return;
      }

      this.$common.infoSubmit(
        "/app/info/find",
        {
          type: "personal",
          dkId: localStorage.getItem("dkId"),
        },
        (res) => {
          if (!res) {
            localStorage.setItem("companyBack", window.location.href);
            this.$router.replace({
              path: "/identity",
              query: { type: "person" },
            });
          } else {
            // this.$router.replace({path: '/personlUnbundling'})
            localStorage.setItem("livingToPage", window.location.href);
            let _this = this;
            let sendData = {
              authType: "person",
              dkId: localStorage.getItem("dkId"),
              //正式环境
              notifyUrl: process.env.NODE_NOTIFY_URL, //faceId回调后台地址
              returnUrl: process.env.NODE_RETURN_URL, //识别后前端回调地址
              //测试环境
              //  notifyUrl: "http://suputech.imwork.net/app/api/living/notify",//faceId回调后台地址
              //  returnUrl: "http://suputech.imwork.net/living"//识别后前端回调地址
            };
            _this.$toast.loading({
              message: "正在加载...",
              forbidClick: true,
              duration: 0,
            });
            _this.$common.infoSubmit(
              "/app/auth/getH5FaceId",
              sendData,
              (res) => {
                _this.$common.pageEventHandle({ eventType: 9 });
                // localStorage.setItem("bizId", res.bizId);
                localStorage.setItem("sendDataTx", JSON.stringify(sendData));
                location.replace(
                  // `https://api.megvii.com/faceid/lite/do?token=${res.token}`
                  `https://ida.webank.com/api/web/login?from=${res.from}&h5faceId=${res.h5faceId}&nonce=${res.nonce}&orderNo=${res.orderNo}&redirectType=${res.redirectType}
                    &resultType=${res.resultType}&sign=${res.sign}&url=${res.url}&userId=${res.userId}&version=${res.version}&webankAppId=${res.webankAppId}
                    `
                );
              },
              (res) => {
                _this.$toast.loading({
                  message: "正在加载...",
                  forbidClick: false,
                });
                _this.isRequest = false;
                _this.isClick = true;
                if (res == "NO_FACE_FOUND") {
                  _this.$toast.fail("请保持图片面部清晰");
                } else if (res == "MULTIPLE_FACES") {
                  _this.$toast.fail("检测到了多张人脸");
                } else {
                  _this.$toast.fail("请重新上传图片");
                }
                // _this.$common.errTip("识别失败");
              },
              60000
            );
          }
        }
      );
    },
  },
};
</script>

<style lang="less" scoped>
.prompt {
  width: 100%;
  padding: 30px;
  color: #303030;
  font-size: 15px;
  font-weight: 400;

  p {
    text-align: center;
  }

  // border-radius: 10px;
  .content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100px;
    margin-top: 30px;
  }

  .content-item1 {
    text-align: center;
    height: 40px;
    line-height: 40px;
    font-size: 15px;
    font-weight: 600;
    width: 100%;
    border: 1px solid #2660ce;
    border-radius: 22.5px;
    background-color: #2660ce;
    color: #fff;
    margin-top: 12px;
  }

  .content-item2 {
    background: #ccc;
    border: none;
  }
}
</style>


// WEBPACK FOOTER //
// src/modules/identityAuthentication/newIdentityPop.vue